module.exports = __webpack_public_path__ + "img/underlineIcon.e52202ea.svg";